import React from 'react';
import {
  contentWithImageChildrenVariants,
  contentWithImageImageVariants,
  contentWithImageVariants,
} from './ContentWithImage.cva';

interface ContentWithImageProps {
  imageUrl: string;
  imageAlt?: string;
  imagePosition?: 'left' | 'right';
  borderPosition?: 'left' | 'right' | 'none';
  isGrayscale?: boolean;
  children: React.ReactNode;
}

const ContentWithImage: React.FC<ContentWithImageProps> = ({
  imageUrl,
  imageAlt = '',
  imagePosition = 'left',
  borderPosition = 'none',
  isGrayscale = false,
  children,
}) => {
  return (
    <div
      className={contentWithImageVariants({
        imagePosition,
      })}
    >
      <div className={contentWithImageImageVariants({ borderPosition })}>
        <img
          src={imageUrl}
          alt={imageAlt}
          className={`object-cover object-center select-none pointer-events-none ${
            isGrayscale ? 'grayscale' : ''
          }`}
          draggable={false}
        />
      </div>
      <div
        className={contentWithImageChildrenVariants({
          imagePosition,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default ContentWithImage;
